<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 footer-copyright">
            <p class="mb-0">
              Copyright {{ new Date().getFullYear() }} © All rights reserved.
            </p>
          </div>
          <div class="col-md-6">
            <p class="pull-right mb-0">
              SCC Portal
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footerpage',
  data(){
    return{
    }
  }
}
</script>
